import { z } from 'zod'
import { format } from 'date-fns'

export enum TimePeriod {
  Yearly = 'yearly',
  Quarterly = 'quarterly',
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
}

export const pulseFiltersSchema = z.object({
  dateFrom: z.date().transform((date) => format(date, 'yyyy-MM-dd')),
  dateTo: z.date().transform((date) => format(date, 'yyyy-MM-dd')),
  companyIds: z.array(z.number()),
  positionTypes: z.array(z.string()).optional(),
  timePeriod: z.nativeEnum(TimePeriod),
})

export type PulseFilters = z.input<typeof pulseFiltersSchema>

export const pulsePaginatedFiltersSchema = pulseFiltersSchema.extend({
  page: z.number(),
  pageSize: z.number(),
})

export type PulsePaginatedFilters = z.input<typeof pulsePaginatedFiltersSchema>
